export default class Accordion {
  public heading: string = '';

  public content: string = '';

  public isCollapsed: boolean = true;

  constructor(heading: string, content: string) {
    this.heading = heading;
    this.content = content;
  }

  get stateAsClassName(): string {
    return this.isCollapsed ? 'facts__fact--collapsed' : '';
  }
}
